import { createContext, useContext, useEffect, useRef } from 'react';
export const OverlayHostContext = createContext(null);
export const useOverlayHost = () => useContext(OverlayHostContext);
/**
 * A tecla nasceu nesta camada?
 *
 * Dentro do elemento dela, sim. Fora de qualquer janela ou diálogo contido — o
 * corpo da página, uma barra —, também: é a camada da frente que está diante
 * de quem digita. Dentro de OUTRA, não.
 */
export const ownsWithin = (element, target) => {
    if (element === null)
        return false;
    if (target instanceof Node && element.contains(target))
        return true;
    return !(target instanceof Element &&
        target.closest('[data-desktop-window]') !== null);
};
/**
 * Um atalho de teclado da tela, e só dela.
 *
 * No lugar de `window.addEventListener('keydown')`, que é o que as telas
 * faziam — e continua sendo o que acontece quando não há um host: o PDV no
 * navegador se comporta exatamente como antes. O listener continua no `window`
 * pelo mesmo motivo que sempre esteve lá: o foco do operador está onde a última
 * ação o deixou, e um atalho que só funciona com o elemento certo focado é um
 * atalho em que ninguém confia.
 *
 * O tratador mais recente é lido de uma ref, então a tela não precisa de lista
 * de dependências: o que ele lê é o estado DESTA renderização, e o listener não
 * é registrado de novo a cada tecla.
 */
export const useScopedKeydown = (handler, enabled = true) => {
    const host = useOverlayHost();
    const latest = useRef(handler);
    // Numa effect, e nunca durante a renderização: uma ref escrita enquanto a
    // tela renderiza é um valor que o React pode descartar.
    useEffect(() => {
        latest.current = handler;
    });
    useEffect(() => {
        if (!enabled)
            return;
        const onKeyDown = (event) => {
            if (host !== null && !host.ownsKeyboard(event))
                return;
            latest.current(event);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [enabled, host]);
};
//# sourceMappingURL=overlay-host.js.map